import { createSlice } from '@reduxjs/toolkit';
import api from 'api';
import formErrorsHandle from '../../../utils/formErrorsHandle';
import toast from 'react-hot-toast';

const initialState = {
  loading: false,
  billingItemsList: []
};
const billingItemsReducer = createSlice({
  name: 'billingItems',
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action.payload
      };
    },
    getList(state, action) {
      return {
        ...state,
        billingItemsList: action.payload?.data?.data,
        count: action.payload?.data?.count
      };
    },
    getById(state, action) {
      return {
        ...state,
        billingItemInfo: action.payload?.data
      };
    }
  }
});

export default billingItemsReducer.reducer;

export const billingItemsActions = billingItemsReducer.actions;

export const createBillingItem = (role) => async () => {
  try {
    const res = await api.post(`api/BillingItem`, role);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const editBillingItem = (data, id) => async () => {
  try {
    const res = await api.put(`api/BillingItem/${id}`, data);
    if (res.status === 200 && res?.data) {
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    return Promise.reject(errors.response?.data);
  }
};
export const getBillingItemsAction = (data) => async (dispatch) => {
  dispatch(billingItemsActions.setLoading(true));
  try {
    const res = await api.get(`api/BillingItem`, { params: data });
    if (res.status === 200 && res?.data) {
      dispatch(billingItemsActions.getList(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(billingItemsActions.setLoading(false));
  }
};
export const getBillingItemById = (id) => async (dispatch) => {
  dispatch(billingItemsActions.setLoading(true));
  try {
    const res = await api.get(`api/BillingItem/${id}`);
    if (res.status === 200 && res?.data) {
      dispatch(billingItemsActions.getById(res.data));
      return Promise.resolve(res?.data);
    }
  } catch (errors) {
    formErrorsHandle(errors.response?.data, []);
    return Promise.reject(errors.response?.data);
  } finally {
    dispatch(billingItemsActions.setLoading(false));
  }
};
export const clearBillingItemById = () => async (dispatch) => {
  dispatch(billingItemsActions.getById(''));
};
